/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export { BrowserXhr } from "./backends/browser_xhr";
export { JSONPBackend, JSONPConnection } from "./backends/jsonp_backend";
export { CookieXSRFStrategy, XHRBackend, XHRConnection } from "./backends/xhr_backend";
export { BaseRequestOptions, RequestOptions } from "./base_request_options";
export { BaseResponseOptions, ResponseOptions } from "./base_response_options";
export { ReadyState, RequestMethod, ResponseContentType, ResponseType } from "./enums";
export { Headers } from "./headers";
export { Http, Jsonp } from "./http";
export { HttpModule, JsonpModule } from "./http_module";
export { Connection, ConnectionBackend, XSRFStrategy } from "./interfaces";
export { Request } from "./static_request";
export { Response } from "./static_response";
export { QueryEncoder, URLSearchParams } from "./url_search_params";
export { VERSION } from "./version";
//# sourceMappingURL=index.js.map